export const shapes = {
  borderRadius: {
    sm: 4,
    md: 5,
  },
};
